import { InfiniteScroll, Progress } from "../../../nq-component";
import BaseListPage from "../../../base/BaseListPage.js";
import { getMonthNumber } from "../../../monthUtils.js";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object/index.js";
import { getCurrentUserUseCase } from "../../../usecases/user/index.js";
import withRouter from "../../../withRouter.js";
import AuditListPagePresenter from "./AuditListPagePresenter.js";
import MonthsContainer from "../../../components/MonthsContainer/index.js";
import CustomLoader from "../../../components/CustomLoader/index.js";
import Filters from "./components/Filters/index.js";
import PageHeader from "../../../components/PageHeader/index.js";
import InputFactory from "../../../components/InputFactory/index.js";
import LegendBox from "../../../components/LegendBox/index.js";
import ClientFilter from "../../../components/ClientFilter/index.js";

class AuditListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      selected: [],
      year: new Date().getFullYear(),
      isMonthsVisible: true,
      month: new Date().getMonth() + 1,
      clientProgress: false,
    };

    this.presenter = new AuditListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      getCurrentUserUseCase(),
    );
  }

  async componentDidUpdate(prevProps) {
    if (this.props.params.collection !== prevProps.params.collection) {
      this.presenter.componentDidMount();
    }
  }

  getCollectionName() {
    return this.props.params.collection;
  }

  getStorageKey() {
    return `selected_client`;
  }

  //Getting Selected Client from Sesstion Storage
  getSelectedClient() {
    const storageKey = this.getStorageKey();
    return JSON.parse(sessionStorage.getItem(storageKey));
  }

  getClientId() {
    return this.props.params.id;
  }

  getMonths() {
    const currentYear = new Date().getFullYear();
    return this.presenter.getMonths(currentYear);
  }

  onView(month, year) {
    const collectionName = this.getCollectionName();

    const storageKey = this.getStorageKey();
    const selectedClient = JSON.parse(sessionStorage.getItem(storageKey));
    const monthInteger = getMonthNumber(month);

    const isAdmin = this.isAdmin();

    if (isAdmin) {
      return this.navigateTo(
        `/${collectionName}/${monthInteger}/${year}/${selectedClient?.id}`,
      );
    }

    return this.navigateTo(`/${collectionName}/${monthInteger}/${year}`);
  }

  onChange(value, field) {
    this.setState({ [field]: value });
  }

  onFilter(e) {
    if (e) e.preventDefault();
    this.presenter.init(this.state.selectedClient);
    this.presenter.getObjects();
  }

  onChangeClient(value, field) {
    const storageKey = this.getStorageKey();
    sessionStorage.setItem(storageKey, JSON.stringify(value));
    this.presenter.onChangeClient();
  }

  showClientProgress() {
    this.setState({ clientProgress: true });
  }

  hideClientProgress() {
    this.setState({ clientProgress: false });
  }

  clientFilter() {
    const collection = this.getCollectionName();
    const schema = this.getSchema(collection);
    const schemas = this.getSchemas();
    const user = this.getCurrentUser();
    const { clientProgress } = this.state;
    const selectedClient = this.getSelectedClient();
    return (
      <ClientFilter
        user={user}
        schemas={schemas}
        schema={schema}
        object={{ selectedClient: selectedClient }}
        onChange={this.onChangeClient.bind(this)}
        type="Pointer"
        target={"clients"}
        progress={clientProgress}
        className="bg-light border-1 border-primary"
        placeholder="Select Client"
        field="selectedClient"
        indexes={["name", "billingCity"]}
        keys={["name", "id", "user"]}
        where={{
          $and: [
            { creator: { id: user?.id } },
            { isActive: true },
            { clientOf: "admin" },
          ],
        }}
        actionButton={false}
      />
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <CustomLoader />;

    const { year, objects, progress, selected, selectedClient } = this.state;
    const user = this.getCurrentUser();

    const months = this.getMonths();
    const yearToNumber = Number(year);

    const collectionName = this.getCollectionName();

    return (
      <>
        <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
          <div className="d-flex flex-column gap-4">
            {/* Header Section */}

            <PageHeader
              breadcrumb={[
                { label: "Home", path: "/" },
                { label: "Reports", path: "/reports" },
                {
                  label: `${collectionName === "sales" ? "Incoming " : "Outgoing "} Transactions`,
                },
              ]}
              title={`${collectionName === "sales" ? "Incoming " : "Outgoing "} Transactions`}
              description={
                collectionName === "sales"
                  ? "View and manage all incoming transactions from your sales records."
                  : "View and manage all outgoing transactions related to expenses and purchases."
              }
              action={this.clientFilter.bind(this)}
            />

            <div
              className="bg-white rounded-3 shadow-sm"
              style={{
                padding: "1.5rem",
                border: "1px solid #e9ecef",
              }}
            >
              <Filters
                year={yearToNumber}
                onChange={this.onChange.bind(this)}
                onFilter={this.onFilter.bind(this)}
              />
            </div>

            <LegendBox compact className="col-12 col-md-11 col-lg-9" />
            {/* Content Card */}

            {progress ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "400px", padding: "3rem" }}
              >
                <CustomLoader />
              </div>
            ) : (
              <div
                className="rounded-3 shadow-sm border-1 border-primary"
                style={{
                  overflow: "hidden",
                }}
              >
                <MonthsContainer
                  type={collectionName}
                  objects={objects}
                  months={months}
                  year={yearToNumber}
                  onView={this.onView.bind(this)}
                  progress={progress}
                  isAdmin={this.isAdmin()}
                />
              </div>
            )}
          </div>
        </InfiniteScroll>
      </>
    );
  }
}

export default withRouter(AuditListPage);
